import React from "react";
import PropTypes from 'prop-types';
import { Typography } from "../../../ecosystem/";

const SelectGroup = ({
    checkSelected,
    disabled = false,
    error = false,
    onChange = () => ({}),
    label = "Radio",
    name = "radio",
    size = "sm"
}) => {
    const radioClasses = [
        `bsw-radio`,
        `bsw-radio--${checkSelected ? "selected" : "unselected"}`,
        `bsw-radio--size-${size}`,
        `${error ? 'bsw-radio--error' : ''}`,
        `${disabled ? 'bsw-radio--disabled' : ''}`
    ].join(' ');

    return (
        <div className={radioClasses}>
            <label className={`radio-container`}>
                <Typography type="body-02" color={disabled ? "$color-secondary-a3" : undefined}>
                    {label}
                </Typography>
                <input
                    type="radio"
                    name={name}
                    value={label}
                    checked={checkSelected}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span className="checkmark" />
            </label>
        </div>
    );
}

SelectGroup.propTypes = {
    checkSelected: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func
}
export default SelectGroup;